import EditIcon from "@mui/icons-material/Edit";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, List, ListItem, ListItemText, TextField, Typography } from "@mui/material";
import { createForm } from "rc-form";
import * as React from "react";
import { DefaultProps } from "../LayoutWrapper";

interface State {
    dialogVisible: boolean;
}

interface Props extends DefaultProps {
    playerData: any;
    dataLoaded: boolean;
    handlePlayerDataChange(name: any, value: any, type?: string): void;
}

class EditUsernameMain extends React.Component<Props, State> {

    constructor(props) {
        super(props);

        this.state = {
            dialogVisible: false,
        };
    }

    showDialog() {
        if (this.props?.playerData?.is_online) {
            return null;
        }

        this.setState({
            dialogVisible: true,
        })
    }

    hideDialog() {
        this.setState({
            dialogVisible: false,
        })
    }

    renderHistory() {
        const history = this.props?.playerData?.name_history || [];

        if (history.length === 0) {
            return <Alert severity="info">
                No username changes has been found!
            </Alert>
        }

        return <List>
            {(this.props?.playerData?.name_history || []).map(username =>
                <ListItem
                    secondaryAction={<Button variant="contained" size="small" onClick={() => this.revertUsername(username)}>
                        Revert
                    </Button>}
                >
                    <ListItemText primary={username}/>
                </ListItem>
            )}
        </List>
    }

    saveUsername() {
        this.props.form.validateFields((error, value) => {
            if (error) {
                return;
            }

            const history = this.props?.playerData?.name_history || [];
            const tempHistory = [...history];

            tempHistory.push(value.username);

            this.props.handlePlayerDataChange("name", value.username, "string");
            this.props.handlePlayerDataChange("name_history", tempHistory, "array");

            this.hideDialog();
        });
    }

    revertUsername(username: string) {
        this.props.handlePlayerDataChange("name", username, "string");
        this.hideDialog();
    }

    render() {
        const { getFieldDecorator, getFieldError } = this.props.form;

        if (!this.props.dataLoaded) {
            return null;
        }

        if (this.props.playerData.is_online) {
            return <Typography variant="h3">
                {this.props.playerData.name}
            </Typography>;
        }

        return <React.Fragment>
            <Typography variant="h3">
                {this.props.playerData.name}
                <EditIcon fontSize="small" style={{ cursor: "pointer", marginLeft: 5 }} onClick={() => this.showDialog()}/>
            </Typography>

            <Dialog
                open={this.state.dialogVisible}
                onClose={() => this.hideDialog()}
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogTitle>Edit Username</DialogTitle>

                <DialogContent dividers>
                    <FormControl
                        fullWidth={true}
                        required={true}
                        error={getFieldError("username")}
                    >
                        {getFieldDecorator("username",
                            {
                                rules: [{
                                    required: true,
                                    message: "Please enter username",
                                }]
                            },
                        )(
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Username"
                                fullWidth
                                variant="outlined"
                            />
                        )}

                    {getFieldError("username") ?
                        <FormHelperText>{getFieldError("username").join(",")}</FormHelperText>
                        : null}
                    </FormControl>

                    <Typography variant="h6" gutterBottom style={{ marginTop: 10 }}>
                        History
                    </Typography>

                    {this.renderHistory()}
                </DialogContent>

                <DialogActions>
                    <Button disableElevation onClick={() => this.hideDialog()} color="primary" variant="contained">
                        Cancel
                    </Button>

                    <Button disableElevation onClick={() => this.saveUsername()} color="primary" variant="contained">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    }
}

export const EditUsername = createForm()(EditUsernameMain);
